/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-native/no-inline-styles */
import React, { useState, useEffect } from 'react';
import {
  View,
  FlatList,
  StyleSheet,
  SafeAreaView,
  InteractionManager,
  Image,
} from 'react-native';
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from 'react-native-responsive-screen';
import { useDispatch, useSelector } from 'react-redux';
import { enableRefreshControl, fetchCafe } from '../store/cafe.slice';
import { Divider, List, Searchbar, Text } from 'react-native-paper';
import { fetchCanteen } from '../store/canteen.slice';
import CategoryItems from '../components/Canteen/CategoryItems';
import Cart from './Cart';
import { theme } from '../theme/theme';
import HttpLoader from '../components/HttpLoader';

/**
 * Main component for the Cash Counter screen.
 * Handles canteen and category selection, search, and layout for tablet view.
 * @param {boolean} enable_ads - Flag to enable ads
 * @param {boolean} enable_quick_actions - Flag to enable quick actions
 */
const CashCounter = ({ enable_ads, enable_quick_actions }) => {
  const dispatch = useDispatch();
  const error = useSelector(state => state.cafe.error);
  const status = useSelector(state => state.cafe.status);
  const canteens = useSelector(state => state.cafe.canteens);
  const categories = useSelector(state => state.canteen.categories);
  const canteen = useSelector(state => state.canteen.canteen);
  const [interactionCompleted, setIntersectionCompleted] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCanteen, setSelectedCanteen] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const isTablet = true;

  /**
   * Handles initial interaction completion.
   */
  useEffect(() => {
    console.log(canteens, 'canteens', 'canteen', canteen)
    const task = InteractionManager.runAfterInteractions(async () => {
      setIntersectionCompleted(true);
    });
    return () => {
      task.cancel();
    };
  }, []);

  /**
   * Fetches cafe (canteen list) data when interaction is complete.
   */
  useEffect(() => {
    if (interactionCompleted) {
      dispatch(fetchCafe());
    }
  }, [interactionCompleted, dispatch]);

  /**
   * Sets the selected canteen and fetches its data when canteens are loaded.
   */
  useEffect(() => {
    if (interactionCompleted && canteens && canteens.length > 0) {
      setSelectedCanteen(canteens[0]);
      dispatch(fetchCanteen({ canteen_id: canteens[0]?.canteen_id }));
    }
  }, [interactionCompleted, canteens, dispatch]);

  /**
   * Sets the selected category when canteen and categories are loaded.
   */
  useEffect(() => {
    if (interactionCompleted && canteen && categories.length > 0) {
      setSelectedCategory(categories[0]);
    }
  }, [interactionCompleted, canteen, categories]);

  /**
   * Handles canteen selection and fetches its categories/items.
   * @param {object} item - Selected canteen object
   */
  const setCanteenHandler = item => {
    setSelectedCategory(null);
    setSelectedCanteen(item);
    dispatch(fetchCanteen({ canteen_id: item?.canteen_id }));
  };

  /**
   * Handles pull-to-refresh action for cafe and canteen data.
   * @param {boolean} retry - Optional retry flag
   */
  const _onRefresh = retry => {
    dispatch(enableRefreshControl({ retry }));
    dispatch(fetchCafe());
  };

  /**
   * Returns the background color for a canteen label.
   * @param {object} item - Canteen object
   * @returns {string} Background color
   */
  const getBGColor = (item) => {
    if (item?.settings?.counter_label_bg) {
      return item?.settings?.counter_label_bg;
    } else {
      return '#fff';
    }
  };

  /**
   * Returns the text color for a canteen label.
   * @param {object} item - Canteen object
   * @returns {string} Text color
   */
  const getTextColor = (item) => {
    if (item?.settings?.counter_text_color) {
      return item?.settings?.counter_text_color;
    } else {
      return '#000';
    }
  };

  return (
    <SafeAreaView edges={['bottom']} style={{ flex: 1 }}>
      <HttpLoader status={status} errorHandler={_onRefresh} error={error} />
      {status === 'succeeded' && (
        <React.Fragment>

          <View style={{ backgroundColor: '#f2f2f2' }}>
            <Text variant="titleMedium" style={[{ padding: 2 }]}>
              Counters
            </Text>
            <View
              style={{ flexDirection: 'row', justifyContent: 'space-evenly' }}>
              {canteens.map((item, index) => {
                const isActive =
                  item?.canteen_id === selectedCanteen?.canteen_id;
                return (
                  <List.Item
                    key={(item?.canteen_id).toString()}
                    style={[
                      {
                        margin: 2,
                        paddingVertical: 0,
                        backgroundColor: '#fff',
                        borderRadius: 4,
                      },
                      isActive && {
                        borderColor: theme.colors.primary,
                        borderWidth: 2,
                      },
                    ]}
                    onPress={() => !isActive && setCanteenHandler(item)}
                    title={() => (
                      <View
                        style={{
                          backgroundColor: getBGColor(item), //'#E0F7FA',
                          borderRadius: 6,
                          paddingHorizontal: 6,
                          paddingVertical: 2,
                        }}>
                        <Text
                          style={{
                            fontSize: 14,
                            textTransform: 'capitalize',
                            color: getTextColor(item), //'#00796B',
                          }}>
                          {item?.canteen_name}
                        </Text>
                      </View>
                    )}
                    titleStyle={[{ fontSize: 14, textTransform: 'capitalize' }]}
                    left={props => (
                      <Image
                        style={{
                          width: 48,
                          height: 48,
                          padding: 4,
                          resizeMode: 'contain',
                        }}
                        source={
                          item?.image
                            ? { uri: item?.image }
                            : require('../assets/default.jpg')
                        }
                      />
                    )}
                  />
                );
              })}
            </View>
          </View>
          <Divider />
          {selectedCanteen && (
            <React.Fragment>
              <View style={styles.container}>
                {/* Categories */}
                <View style={styles.leftPane}>
                  <Text
                    variant="titleMedium"
                    style={[styles.sectionTitle, { paddingLeft: 8 }]}>
                    Categories
                  </Text>
                  <View
                    style={{ flex: 1, backgroundColor: '#f1f1f3', padding: 4 }}>
                    <FlatList
                      data={categories}
                      keyExtractor={item => (item?.category_id).toString()}
                      renderItem={({ item }) => (
                        <List.Item
                          style={[
                            { backgroundColor: '#fff', borderRadius: 0 },
                            item?.category_id ===
                            selectedCategory?.category_id && {
                              backgroundColor: theme.colors.primary,
                            },
                          ]}
                          onPress={() => setSelectedCategory(item)}
                          title={item?.category_name}
                          titleStyle={[
                            { fontSize: 14, textTransform: 'capitalize' },
                            item?.category_id ===
                            selectedCategory?.category_id && { color: '#fff' },
                          ]}
                        />
                      )}
                    />
                  </View>
                </View>

                {/* Items */}
                <View style={styles.centerPane}>
                  {selectedCategory && (
                    <React.Fragment>
                      <Text variant="titleMedium" style={styles.sectionTitle}>
                        {selectedCategory?.category_name} Items
                      </Text>
                      <View style={{ marginVertical: 2 }}>
                        <Searchbar
                          placeholder="Search"
                          onChangeText={setSearchQuery}
                          value={searchQuery}
                          style={{
                            height: 44,
                            margin: 6,
                          }}
                          inputStyle={{
                            minHeight: 0,
                          }}
                        />
                      </View>
                      <CategoryItems
                        searchQuery={searchQuery}
                        isTablet={isTablet}
                        canteen={selectedCanteen}
                        category={selectedCategory}
                      />
                    </React.Fragment>
                  )}
                </View>
                {/* Cart */}
                <View style={styles.rightPane}>
                  <Text variant="titleMedium" style={styles.sectionTitle}>
                    Your Cart
                  </Text>
                  <Cart isTablet={isTablet} />
                </View>
              </View>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flex: 1,
  },
  mobileContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftPane: {
    width: wp('20%'),
    backgroundColor: '#ffffff',
    paddingVertical: wp('1%'),
    paddingHorizontal: wp('0.2%'),
    borderRightColor: '#f1f1f3',
    borderRightWidth: 1,
  },
  centerPane: {
    width: wp('50%'),
    padding: wp('1%'),
    backgroundColor: '#ffffff',
    borderRightColor: '#f1f1f3',
    borderRightWidth: 1,
  },
  rightPane: {
    width: wp('30%'),
    backgroundColor: '#ffffff',
    padding: wp('1%'),
  },
  sectionTitle: {
    marginBottom: hp('1%'),
    textTransform: 'capitalize',
  },
  category: {
    padding: hp('1%'),
    textTransform: 'uppercase',
  },
  activeCategory: {
    backgroundColor: '#ddd',
    fontWeight: 'bold',
  },
  itemCard: {
    flex: 1,
    margin: wp('1%'),
    padding: wp('1%'),
    backgroundColor: '#fff',
    alignItems: 'center',
    borderRadius: 10,
    elevation: 3,
  },
  productImage: {
    width: wp('15%'),
    height: wp('15%'),
    resizeMode: 'contain',
    marginBottom: hp('1%'),
  },
  itemName: {
    fontSize: wp('1%'),
    fontWeight: '500',
  },
  addToCart: {
    color: 'green',
    marginTop: hp('0.5%'),
  },
  cartItem: {
    paddingVertical: hp('1%'),
    borderBottomWidth: 1,
    borderColor: '#ccc',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  removeBtn: {
    color: 'red',
  },
  emptyCart: {
    fontStyle: 'italic',
    color: '#888',
  },
  cartFeedback: {
    position: 'absolute',
    bottom: hp('2%'),
    left: wp('40%'),
    backgroundColor: '#000',
    padding: wp('2%'),
    borderRadius: 5,
    opacity: 0,
  },
});

export default CashCounter;
